import { createAction } from 'redux-actions';

export const setNextFormStep = createAction('SET_NEXT_FORM_STEP');

export const setPreviousFormStep = createAction('SET_PREVIOUS_FORM_STEP');

export const setInitialFormStep = createAction('SET_INITIAL_FORM_STEP');
